export default __webpack_public_path__ + "static/media/webinar-banner.fa53a53d.svg";